export class Item {
  public id: string;
  public field1?: string;
  public field2?: number;
  public field3?: string | number;
  public field4?: string | number;
  public field5?: Date | string;
  public data?: any;

  constructor(id:string,
              field1: string,
              field2: number,
              field3?: string | number,
              field4?: string | number,
              field5?: Date | string,
              data?: any) {
    this.id = id;
    this.field1 = field1;
    this.field2 = field2;
    this.field3 = field3;
    this.field4 = field4;
    this.field5 = field5 ? new Date(field5) : '';
    this.data = data;
  }
}
